<template>
  <div v-if="viewport" class="page-wrap">
    <banner :nav-index="5" :height="1100">
      <template slot="banner">
        <div class="banner">
          <div class="centre" :style="{'will-change':'transform',transform:`translate3d(0,${transLateY}px,0)`}">
            <div class="letter">
              <h1 class="conf-title">脑机接口开发者大会</h1>
              <div class="line"></div>
              <p class="desc top">脑机接口开发者大会（英文：Brain-Computer Interface Developers Conference，简称BCI Developers Conference）是由北京姬械机科技（Maschine Robot）于 2023 年发起的全球脑机接口技术与产品行业开发者大会，是国内脑机接口领域专注于开发者群体的技术交流平台。大会聚焦脑机接口技术与产品赛道，围绕技术研发、工程实践、场景开发等维度，搭建贯通医疗、产业、学术、研发、开发者与资本的脑与智能技术发展交流流平台。大会于2023年发起，已于2024年、2025年连续举办两届，第三届即将于2026年8月举办，是面向全球脑机接口行业专业从业者的年度技术与产品交流活动。</p>
<!--              <p class="desc top">由北京姬械机科技（Maschine Robot）于2023年发起的全球脑机接口技术与产品行业开发者大会，是国内脑机接口领域专注于开发者群体的技术交流平台。</p>
              <p class="desc">聚焦脑机接口技术与产品赛道，搭建贯通医疗、产业、学术、研发、开发者与资本的脑与智能技术发展交流平台。</p>-->
              <div class="frame-row">
                <div class="frame">Ignite · Reshape The Future</div>
                <div class="frame-logo-wrap">
                  <img class="frame-logo" src="@/assets/conference/image1-3.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </banner>

    <div style="position:relative;z-index:2;background-color:#fff">

      <!-- 大会简介 -->
      <section class="intro">
        <div class="centre-box">
          <div class="section-title">
            <h2>大会简介</h2>
            <div class="line-bar"></div>
          </div>
          <div class="intro-content">
            <div class="intro-text">
              <p>脑机接口开发者大会（BCI Developers Conference）是国内脑机接口领域专注于行业技术与应用开发者群体的技术交流活动。大会核心面向脑机接口行业的技术开发者与应用者，同时开放邀请对脑机接口技术与应用感兴趣的各个行业的管理者与应用开发者。</p>
              <p class="mt20">大会主要为参会人员分享全球脑机接口技术的发展进展与趋势，从脑机接口技术产品设计、脑机硬件开发、脑机数据构建、脑机AI算法研发、脑机接口交互应用、脑机接口应用安全与伦理等多个模块进行技术分享和研发示范。</p>
              <p class="mt20">大会旨在响应国家科技发展战略，将脑机接口技术规模化创新应用推广到各个行业场景，进一步推动脑机交互前沿科技新质生产力转化落地，赋能相关不同行业发展。</p>
              <div class="info-grid">
                <div class="info-item"><span class="label">发起单位</span><span class="value">北京姬械机科技（Maschine Robot）</span></div>
                <div class="info-item"><span class="label">发起时间</span><span class="value">2023年</span></div>
                <div class="info-item"><span class="label">英文名称</span><span class="value">BCI Developers Conference</span></div>
                <div class="info-item"><span class="label">举办频次</span><span class="value">自2024年起每年定期举办</span></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 2023发起背景：Final Fantancy 三大趋势 -->
      <section class="fantancy">
        <div class="centre-box">
          <div class="section-title">
            <h2>大会背景 · Final Fantancy</h2>
            <div class="line-bar"></div>
<!--
            <p class="sub-title">姬械机科技于2023年通过脑机未来启示录——Final Fantancy，预测了人类未来的生活型态与文明形态将如何演变，并展示了从2026年到2326年300年间，人类生活变迁的5个场景。</p>
-->         <p class="sub-title page-width-desc">国内脑机接口产业于 2018 年进入萌芽发展期，行业快速扩张，大量初创企业集中涌现；2022 年后行业进入调整下行阶段，经过市场筛选，原有上千家初创团队仅剩十余家企业持续开展相关研发业务。行业发展的起伏，反映出国内前沿科技产业化进程中存在的诸多现实难题。</p>

            <p class="sub-title page-width-desc">在此背景下，姬械机科技于2023年组建了脑机行业专项技术发展项目组，希望通过组织创办脑机接口开发者大会，再次点燃人们对于脑机接口这种作为一种全新交互技术的前沿科技方向的关注，点燃脑机接口行业发展的热火，提升行业整体关注度，推动脑机接口技术落地应用，让脑机接口成为新质生产力的重要组成部分。</p>
            <h2>历届概况</h2>
            <div class="line-bar"></div>
            <p class="sub-title page-width-desc">活动会议组成（2023年）</p>
            <p class="sub-title page-width-desc">2023月6月6日在北京正式成立，脑机接口开发者大会专项项目组，主题为：脑与智能技术发展行业生态建设，同时发布了脑机未来启示录- Final Fantacy，通过畅想未来脑机在人类社会与文明进程中的应用与发展，旨在通过设置面向全行业的开源活动组织脑机接口开发者大会（BCI Developers Conference）让更多不同行业、及脑机从业专业人员、脑机接口创业公司及市场化基金资本等不同的群体从更全面更深入的角度理解脑机接口的技术路线与应用方方案，从而让大家联手共同推进脑机接口技术进步与行业发展及产业应用。</p>
            <h2>最终幻想三大核心趋势</h2>
            <div class="line-bar"></div>
          </div>
          <div class="trend-list">
            <div class="trend-item">
              <div class="trend-text">
                <p class="trend-num">趋势1</p>
                <p class="trend-desc">在人类5感已经被充分开发和利用的今天，脑机接口让我们看到人类<strong>第六感官</strong>的新大陆！</p>
              </div>
              <img class="trend-img" src="@/assets/conference/image2-1.png" alt="趋势1">
            </div>
            <div class="trend-item">
              <div class="trend-text">
                <p class="trend-num">趋势2</p>
                <p class="trend-desc">我们的人机交互的模式一定会跳出二维的平面，走向大脑甚至走入大脑，并带来信息传递、信息储存的重变革，和交互体验的全新升级。</p>
              </div>
              <img class="trend-img" src="@/assets/conference/image3-1.png" alt="趋势2">
            </div>
            <div class="trend-item">
              <div class="trend-text">
                <p class="trend-num">趋势3</p>
                <p class="trend-desc">人类文明一定会走出地球，走向多星球文明的阶段。</p>
              </div>
              <img class="trend-img trend-img-contain" src="@/assets/conference/image4-1.png" alt="趋势3">
            </div>
          </div>
          <div class="scene-caption">顺着这三个大趋势，姬械机科技预测了人类未来的生活型态和文明形态将如何演变，并展示了从2026年到2326年300年间，人类生活变迁的5个场景。</div>
          <div class="scene-wrap">
            <img src="@/assets/conference/image5-1.png" alt="2026-2326年人类生活变迁5个场景">
          </div>
        </div>
      </section>

      <!-- 第一届大会 2024 -->
      <section class="edition-section ed1">
        <div class="centre-box">
          <div class="section-title">
            <span class="year-badge">2024</span>
            <h2>第一届脑机接口开发者大会</h2>
            <div class="line-bar"></div>
            <p class="meta-line">2024年8月16日 &nbsp;·&nbsp; 北京</p>
<!--            <p class="sub-title">主题：Ignite · Reshape The Future。面向脑机接口行业技术人员、高校学生、研究人员、创业公司、政府及投资方等多类群体开放，旨在让各界从更全面深入的角度理解脑机接口技术路线与应用方案。</p>
            --><p class="sub-title page-width-desc">经过2023年的方案设计与活动发起，首届脑机接口技术开发者大会由北京姬械机科技主办，于2024年8月16日在北京举办。会议主题为lgnite-Resahpe The Future，旨在通过此次会议让更多不同行业、及脑机从业专业人员、脑机接口创业公司等不同的群体从更全面更深入的角度理解脑机接口的技术路线与应用方案。大会参与人群覆盖高校学生、研究人员、创业公司、行业客户、科技爱好者、政府、投资方等。</p>
          </div>
          <div class="kv-agenda">
            <img class="kv-img" src="@/assets/conference/image7.png" alt="第一届大会主视觉">
            <img class="agenda-img" src="@/assets/conference/image8-1.png" alt="第一届会议日程">
          </div>
          <div class="photo-grid-4">
            <img src="@/assets/conference/image9-1.jpeg" alt="">
            <img src="@/assets/conference/image10-1.jpeg" alt="">
            <img src="@/assets/conference/image11-1.jpeg" alt="">
            <img src="@/assets/conference/image12-1.jpeg" alt="">
          </div>
        </div>
      </section>

      <!-- 第二届大会 2025 -->
      <section class="edition-section ed2">
        <div class="centre-box">
          <div class="section-title">
            <span class="year-badge">2025</span>
            <h2>第二届脑机接口开发者大会</h2>
            <div class="line-bar"></div>
            <p class="meta-line">2025年8月16日—17日 &nbsp;·&nbsp; 成都锦江</p>
<!--            <p class="sub-title">邀请来自MIT、清华大学、北京大学、北京师范大学、中科院自动化所、华南理工大学、电子科技大学等机构的知名研究学者，以及多位产业技术专家进行主题报告，涵盖脑机接口技术与应用、类脑智能、俱身智能等方向，吸引近千名参会人员。</p>
            --><p class="sub-title page-width-desc">第二届脑机接口技术开发者大会由姬械机科技发起，于2025年8月16日-17日在成都锦江举行。大会围绕脑与智能技术主题，邀请了来自脑机接口与类脑智能2个方向的十多位来自MIT，清华大学，北京大学，北京师范大学，中科院自动化所，华南理工大学，电子科技大学的多名知名研究学者，以及多位产业技术专家和行业科技领袖进行了十多项相关主题的技术与产业科技技术分享，吸引了约近千人规模的参会人员。大会报告涵盖了脑机接口技术与应用，类脑智能技术与应用，类脑俱身智能技术与应用等多个主题。</p>

          </div>
          <div class="agenda-full">
            <img src="@/assets/conference/image13-3.jpeg" alt="第二届大会完整议程">
          </div>
          <div class="ed2-row">
            <img src="@/assets/conference/image18-1.png" alt="会场全景">
            <img src="@/assets/conference/image19-1.png" alt="集体合影">
          </div>
          <div class="ed2-row">
            <img src="@/assets/conference/image17-1.png" alt="入场签到">
            <img src="@/assets/conference/image14-1.png" alt="展区前台">
            <img src="@/assets/conference/image15-1.png" alt="展柜陈列">
          </div>
          <div class="ed2-full">
            <img src="@/assets/conference/image16-1.png" alt="大会出版物">
          </div>
        </div>
      </section>

      <!-- 第三届预告 -->
      <section class="upcoming">
        <div class="centre-box">
          <div class="upcoming-card">
            <div class="upcoming-left">
              <span class="year-badge light">2026</span>
              <h2>第三届脑机接口开发者大会</h2>
              <p class="meta-line-light">2026年8月 &nbsp;·&nbsp; 敬请期待</p>
              <p class="upcoming-desc">以"脑机接口技术与产品规模化应用"为主题，聚焦脑与智能技术方向，围绕技术研发、工程实践、产品开发、场景应用等内容开展交流与研讨，搭建面向脑机接口开发者的技术与工程交流平台。</p>
              <div class="upcoming-slogan">Ignite · Reshape The Future</div>
            </div>

          </div>
        </div>
      </section>

      <!-- 合作单位 -->
      <section class="partners">
        <div class="partners-inner">
          <h2>合作单位</h2>
          <div class="partners-grid">
            <div class="partner-item">
              <div class="partner-logo"><img src="@/assets/harmonize.png"></div>
              <p>北京协和医院</p>
            </div>
            <div class="partner-item">
              <div class="partner-logo"><img src="@/assets/zheda.png"></div>
              <p>浙江大学</p>
            </div>
            <div class="partner-item">
              <div class="partner-logo"><img src="@/assets/dianzi.png"></div>
              <p>电子科技大学</p>
            </div>
            <div class="partner-item">
              <div class="partner-logo"><img src="@/assets/jd-university.png"></div>
              <p>上海交通大学</p>
            </div>
            <div class="partner-item">
              <div class="partner-logo"><img src="@/assets/Stanford.png"></div>
              <p>斯坦福大学</p>
            </div>
            <div class="partner-item">
              <div class="partner-logo dianzi.png"><img src="@/assets/mit.png"></div>
              <p>MIT</p>
            </div>
          </div>
        </div>
      </section>

      <relation></relation>
    </div>
  </div>

  <!-- 手机端 -->
  <div v-else class="phone-wrap">
    <div class="ph-background">
      <div class="ph-nav">
        <div class="ph-logo"><img src="@/assets/phone/phone-logo.png"></div>
        <div @click="onList" class="ph-fork"><span class="iconfont icon-liebiaoshitucaidan"></span></div>
      </div>
      <div class="ph-hero">
        <img class="ph-conf-logo" src="@/assets/conference/image1.png" alt="脑机接口开发者大会">
        <div class="ph-line"></div>
        <p class="ph-sub">由姬械机科技发起，面向全球脑机接口行业专业从业者的年度技术与产品交流活动。</p>
        <div class="ph-slogan">Ignite · Reshape The Future</div>
      </div>
      <div v-show="list" class="ph-list"><phoneNav @onHide="onHide"></phoneNav></div>
    </div>

    <div class="ph-section">
      <h2>大会简介</h2>
      <div class="ph-divider"></div>
      <p>脑机接口开发者大会（BCI Developers Conference）是国内脑机接口领域专注于行业技术与应用开发者群体的技术交流活动，聚焦脑机接口技术与产品赛道，围绕技术研发、工程实践、场景开发等维度，搭建贯通医疗、产业、学术、研发、开发者与资本的脑与智能技术发展交流平台。</p>
    </div>

    <div class="ph-section dark">
      <h2>大会背景 · Final Fantancy</h2>
      <div class="ph-divider white"></div>
      <p class="ph-light-text">顺着三个大趋势，姬械机科技预测了人类未来的生活型态和文明形态，展示了从2026年到2326年300年间人类生活变迁的5个场景。</p>
      <img class="ph-full-img blend mt20" src="@/assets/conference/image2.png" alt="趋势1">
      <img class="ph-full-img blend mt12" src="@/assets/conference/image3.png" alt="趋势2">
      <img class="ph-full-img blend mt12" src="@/assets/conference/image4.png" alt="趋势3">
      <img class="ph-full-img blend mt12" src="@/assets/conference/image5-1.png" alt="5个场景">
    </div>

    <div class="ph-section">
      <div class="ph-year-row"><span class="ph-year">2024</span><span class="ph-tag">第一届</span></div>
      <h2>第一届脑机接口开发者大会</h2>
      <div class="ph-divider"></div>
      <p class="ph-meta">2024年8月16日 · 北京</p>
      <img class="ph-full-img mt12" src="@/assets/conference/image7.png" alt="">
      <img class="ph-full-img mt12" src="@/assets/conference/image8-1.png" alt="第一届日程">
      <div class="ph-photo-grid">
        <img src="@/assets/conference/image9-1.jpeg" alt="">
        <img src="@/assets/conference/image10-1.jpeg" alt="">
        <img src="@/assets/conference/image11-1.jpeg" alt="">
        <img src="@/assets/conference/image12-1.jpeg" alt="">
      </div>
    </div>

    <div class="ph-section dark">
      <div class="ph-year-row"><span class="ph-year light">2025</span><span class="ph-tag light">第二届</span></div>
      <h2 class="light">第二届脑机接口开发者大会</h2>
      <div class="ph-divider white"></div>
      <p class="ph-meta light">2025年8月16—17日 · 成都锦江</p>
      <img class="ph-full-img mt12" src="@/assets/conference/image13-3.jpeg" alt="第二届议程">
      <div class="ph-photo-grid">
        <img src="@/assets/conference/image18-1.png" alt="">
        <img src="@/assets/conference/image17-1.png" alt="">
        <img src="@/assets/conference/image14-1.png" alt="">
        <img src="@/assets/conference/image15-1.png" alt="">
      </div>
      <img class="ph-full-img mt12" src="@/assets/conference/image19-1.png" alt="第二届合影">
      <img class="ph-full-img" src="@/assets/conference/image16-1.png" alt="大会出版物">
    </div>


    <div class="ph-section bg-light">
      <h2>合作单位</h2>
      <div class="ph-divider"></div>
      <div class="ph-partners-grid">
        <div class="ph-partner-item">
          <div class="ph-partner-logo"><img src="@/assets/harmonize.png" alt="北京协和医院"></div>
          <p>北京协和医院</p>
        </div>
        <div class="ph-partner-item">
          <div class="ph-partner-logo"><img src="@/assets/zheda.png" alt="浙江大学"></div>
          <p>浙江大学</p>
        </div>
        <div class="ph-partner-item">
          <div class="ph-partner-logo"><img src="@/assets/dianzi.png" alt="电子科技大学"></div>
          <p>电子科技大学</p>
        </div>
        <div class="ph-partner-item">
          <div class="ph-partner-logo"><img src="@/assets/jd-university.png" alt="上海交通大学"></div>
          <p>上海交通大学</p>
        </div>
        <div class="ph-partner-item">
          <div class="ph-partner-logo"><img src="@/assets/Stanford.png" alt="斯坦福大学"></div>
          <p>斯坦福大学</p>
        </div>
        <div class="ph-partner-item">
          <div class="ph-partner-logo"><img src="@/assets/mit.png" alt="MIT"></div>
          <p>MIT</p>
        </div>
      </div>
    </div>

    <div class="ph-upcoming">
      <img class="ph-conf-logo small" src="@/assets/conference/image1.png" alt="">
      <h2>第三届脑机接口开发者大会</h2>
      <p class="ph-meta light">2026年8月 · 敬请期待</p>
      <p class="ph-light-text mt12">以"脑机接口技术与产品规模化应用"为主题，聚焦脑与智能技术方向，围绕技术研发、工程实践、产品开发、场景应用等内容开展交流。</p>
      <div class="ph-slogan">Ignite · Reshape The Future</div>
    </div>

    <phoneFooter></phoneFooter>
  </div>
</template>

<script>
import banner from '@/components/banner'
import relation from '@/components/footer'
import phoneNav from '@/components/phoneNav/index'
import phoneFooter from '@/components/phoneFooter'

export default {
  name: 'conference',
  components: { banner, relation, phoneNav, phoneFooter },
  data() {
    return {
      toTop: 0,
      transLateY: 0,
      viewport: true,
      screenWidth: null,
      list: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.screenWidth = document.body.clientWidth
    if (document.documentElement.clientWidth < 1280) this.viewport = false
    window.onresize = () => { this.screenWidth = document.body.clientWidth }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {
    screenWidth(n) { this.viewport = n > 1024 }
  },
  methods: {
    onList() { setTimeout(() => { this.list = true }, 200) },
    onHide() { setTimeout(() => { this.list = false }, 200) },
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop < 900) {
        this.transLateY = this.toTop <= scrollTop ? scrollTop / 10 : -scrollTop / 10
      }
      this.toTop = scrollTop
    }
  }
}
</script>

<style scoped>
/* ===== 桌面端 ===== */
.banner {
  min-height: 1100px;
  height: auto;
}

.banner .centre {
  width: 1200px;
  min-height: 1100px;
  margin: 0 auto;
  padding-top: 120px;
  padding-bottom: 140px;
  box-sizing: border-box;
}

.banner .centre .letter { flex: 1; }

.conf-title {
  color: #FFFFFF;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 600;
  font-size: 54px;
  line-height: 76px;
  letter-spacing: 2px;
}

.banner .centre .letter .line {
  margin-top: 60px;
  width: 60px;
  height: 6px;
  background-color: #FFFFFF;
}

.banner .centre .letter .desc {
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 50px;
  color: #FFFFFF;
  letter-spacing: 1px;
  opacity: 0.8;
}
.banner .centre .letter .top { margin-top: 76px; padding-bottom: 0; }

.banner .centre .letter .frame {
  margin-top: 0;
  padding: 0 0;
  height: 100px;
  width: fit-content;
  white-space: nowrap;
  font-weight: 600;
  font-size: 28px;
  display: flex;
  align-items: center;
  border-top: 1px solid #FFFFFF;
  border-bottom: 1px solid #FFFFFF;
  color: #FFFFFF;
  font-family: 'PingFang SC';
}

.frame-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 50px;
}

.frame-row .frame {
  margin-top: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.frame-logo-wrap {
  line-height: 0;
}

.frame-logo {
  height: 100px;
  width: auto;
  flex-shrink: 0;
}

.banner-kv {
  flex: 0 0 500px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: 20px;
}
.banner-kv img {
  width: 480px;
  border-radius: 8px;
  opacity: 0.88;
}

/* 通用 */
.centre-box { width: 1200px; margin: 0 auto; }

.section-title { margin-bottom: 48px; }
.section-title h2 {
  font-size: 40px;
  font-weight: 600;
  color: #111111;
  font-family: 'PingFang SC';
  margin-bottom: 18px;
  margin-top: 12px;
}
.line-bar { width: 48px; height: 5px; background-color: #111111; margin-bottom: 24px; }
.sub-title { font-size: 17px; line-height: 32px; color: #555555; max-width: 900px; font-family: 'PingFang SC'; }
.page-width-desc { max-width: 100%; }
.meta-line { font-size: 16px; color: #777777; margin-bottom: 14px; font-family: 'PingFang SC'; }
.year-badge {
  display: inline-block;
  font-size: 13px;
  font-weight: 600;
  color: #FFFFFF;
  background: linear-gradient(135deg, #545f65, #8cafb8);
  padding: 3px 14px;
  border-radius: 20px;
  margin-bottom: 12px;
  letter-spacing: 1px;
  font-family: 'PingFang SC';
}

/* 大会简介 */
.intro { padding: 90px 0 80px; }
.intro-text p { font-size: 17px; line-height: 32px; color: #444444; font-family: 'PingFang SC'; }
.mt20 { margin-top: 20px; }
.info-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1px;
  margin-top: 48px;
  background: #E8ECF0;
  border: 1px solid #E8ECF0;
}
.info-item {
  display: flex;
  flex-direction: column;
  padding: 24px 28px;
  background: #FFFFFF;
}
.info-item .label { font-size: 13px; color: #999999; margin-bottom: 8px; }
.info-item .value { font-size: 16px; font-weight: 500; color: #111111; line-height: 1.5; white-space: nowrap; }

/* Final Fantancy */
.fantancy { padding: 80px 0 90px; background: #F0F3F5; }
.fantancy .section-title h2 { color: #111111; }
.trend-list { display: flex; gap: 32px; margin-bottom: 40px; }
.trend-item { flex: 1; display: flex; flex-direction: column; }
.trend-text { flex: 1; padding: 16px 0 12px; }
.trend-num { font-weight: 600; font-size: 18px; color: #111111; margin-bottom: 8px; }
.trend-desc { font-size: 14px; line-height: 24px; color: #444444; }
.trend-img { width: 100%; height: auto; border-radius: 4px; display: block; }
.trend-img-contain { height: 104px; width: 100%; object-fit: contain; }
.scene-caption { font-size: 16px; line-height: 30px; color: #444444; margin-bottom: 16px; }
.scene-wrap { margin-top: 8px; }
.scene-wrap img {
  width: 100%;
  display: block;
  border-radius: 4px;
  mix-blend-mode: multiply;
}

/* 历届大会通用 */
.edition-section { padding: 80px 0 90px; }
.ed1 { background: #FFFFFF; }
.ed2 { background: #F0F3F5; }

.kv-agenda { display: flex; gap: 12px; margin-bottom: 12px; align-items: center; }
.kv-img { height: 555px; width: auto; border-radius: 6px; flex: none; }
.agenda-img { height: 555px; width: auto; border-radius: 6px; flex: none; }

.photo-grid-4 { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; }
.photo-grid-4 img { width: 100%; border-radius: 4px; object-fit: cover; aspect-ratio: 4/3; }

.agenda-full { margin-bottom: 12px; }
.agenda-full img { width: 100%; border-radius: 6px; }
.ed2-full { margin-bottom: 12px; }
.ed2-full img { width: 100%; border-radius: 6px; display: block; }
.ed2-row { display: flex; gap: 12px; margin-bottom: 12px; align-items: stretch; }
.ed2-row img { flex: 1; width: 0; border-radius: 6px; object-fit: cover; }

.photo-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.photo-grid-3 img { width: 100%; border-radius: 4px; object-fit: cover; aspect-ratio: 4/3; }
.photo-grid-3 .span2 { grid-column: span 2; aspect-ratio: 8/3; }

/* 出版物 */
.publications { padding: 80px 0; background: #FFFFFF; }
.pub-img-wrap img { width: 100%; max-width: 900px; display: block; margin: 0 auto; }

/* 合作单位 */
.partners { background: #FFFFFF; padding: 0 0 80px; }
.partners-inner {
  width: 1200px;
  margin: 100px auto;
  background: #F0F3F5;
  border-radius: 12px;
  padding: 70px 80px 80px;
  box-sizing: border-box;
}
.partners-inner h2 {
  margin-bottom: 60px;
  font-weight: 600;
  font-size: 32px;
}
.partners-grid {
  display: flex;
  justify-content: space-between;
}
.partner-item {
  height: 160px;
  width: 160px;
  background-color: #FFFFFF;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.partner-logo {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.partner-logo img { width: 80px; height: 80px; object-fit: contain; }
.mit-wrap img { width: 84px; height: 50px; }
.partner-item p {
  margin-top: 12px;
  text-align: center;
  color: #111111;
  font-size: 16px;
}

/* 第三届预告 */
.upcoming {
  padding: 80px 0 90px;
  background: #FFFFFF;
}
.upcoming-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  background: #FFFFFF;
}
.upcoming-left { width: 100%; max-width: 100%; }
.upcoming .upcoming-left h2 { font-size: 42px; font-weight: 600; color: #111111; margin: 12px 0 6px; }
.upcoming .meta-line-light { font-size: 16px; color: #777777; margin-bottom: 24px; }
.upcoming .upcoming-desc { font-size: 17px; line-height: 32px; color: #555555; }
.upcoming .upcoming-slogan {
  margin-top: 40px;
  padding: 14px 0;
  font-size: 26px;
  font-weight: 600;
  color: #111111;
  border-top: 1px solid rgba(17,17,17,0.18);
  border-bottom: 1px solid rgba(17,17,17,0.18);
  display: inline-block;
  min-width: 400px;
}
.upcoming-right img { height: 100px; mix-blend-mode: screen; opacity: 0.9; }
.upcoming .year-badge.light { background: linear-gradient(135deg, #545f65, #8cafb8); }
.line-bar.light { background-color: rgba(255,255,255,0.6); }

/* ===== 手机端 ===== */
.phone-wrap { font-family: 'PingFang SC'; }

.ph-background {
  background-image: linear-gradient(to bottom right, #545f65, #814e54);
  padding-bottom: 1.5rem;
}
.ph-nav { display: flex; justify-content: space-between; padding: 1.14rem 0.6rem 0; }
.ph-logo { display: flex; align-items: center; height: 0.43rem; }
.ph-logo img { height: 0.35rem; }
.ph-fork { height: 0.43rem; line-height: 0.43rem; color: #FFFFFF; }
.ph-fork .iconfont { font-size: 0.36rem; }

.ph-hero { padding: 1rem 0.6rem 0; }
.ph-conf-logo { height: 0.9rem; mix-blend-mode: screen; }
.ph-conf-logo.small { height: 0.65rem; mix-blend-mode: screen; opacity: 0.85; }
.ph-line { margin: 0.4rem 0 0.3rem; width: 0.24rem; height: 0.03rem; background-color: #FFFFFF; }
.ph-sub { font-size: 0.24rem; line-height: 0.42rem; color: rgba(255,255,255,0.85); width: 5.6rem; }
.ph-slogan {
  margin-top: 0.5rem;
  font-size: 0.26rem;
  font-weight: 600;
  color: #FFFFFF;
  padding: 0.18rem 0;
  border-top: 1px solid rgba(255,255,255,0.4);
  border-bottom: 1px solid rgba(255,255,255,0.4);
  display: inline-block;
}
.ph-list { width: 100%; position: fixed; top: 0; left: 0; z-index: 9; }

.ph-section { padding: 0.8rem 0.6rem; background: #FFFFFF; }
.ph-section.dark { background: linear-gradient(135deg, #545f65 0%, #8cafb8 100%); }
.ph-section.bg-light { background: #F0F3F5; }
.ph-section h2 { font-size: 0.34rem; font-weight: 600; color: #111111; margin-bottom: 0.24rem; }
.ph-section h2.light { color: #FFFFFF; }
.ph-divider { width: 0.4rem; height: 0.04rem; background: #111111; margin-bottom: 0.36rem; }
.ph-divider.white { background: rgba(255,255,255,0.6); }
.ph-section p { font-size: 0.24rem; line-height: 0.44rem; color: #444444; }
.ph-light-text { font-size: 0.24rem; line-height: 0.44rem; color: rgba(255,255,255,0.85); }
.ph-full-img { width: 100%; border-radius: 0.06rem; display: block; }
.ph-full-img.blend { mix-blend-mode: multiply; }
.ph-partners-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.2rem;
  margin-top: 0.3rem;
}
.ph-partner-item {
  background: #FFFFFF;
  border-radius: 0.12rem;
  min-height: 1.8rem;
  padding: 0.24rem 0.12rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.ph-partner-logo {
  width: 0.9rem;
  height: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ph-partner-logo img {
  width: 0.9rem;
  height: 0.9rem;
  object-fit: contain;
}
.ph-partner-item p {
  margin-top: 0.14rem;
  font-size: 0.22rem;
  color: #111111;
  text-align: center;
  line-height: 1.4;
}
.mt12 { margin-top: 0.2rem; }
.ph-photo-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0.12rem; margin-top: 0.2rem; }
.ph-photo-grid img { width: 100%; border-radius: 0.06rem; object-fit: cover; aspect-ratio: 4/3; }
.ph-meta { font-size: 0.22rem; color: #888888; margin-bottom: 0.1rem; }
.ph-meta.light { color: rgba(255,255,255,0.65); }
.ph-year-row { display: flex; align-items: baseline; gap: 0.16rem; margin-bottom: 0.16rem; }
.ph-year { font-size: 0.42rem; font-weight: 700; color: #111111; }
.ph-year.light { color: #FFFFFF; }
.ph-tag { font-size: 0.2rem; color: #666; border: 1px solid #CCC; padding: 0.02rem 0.14rem; border-radius: 0.2rem; }
.ph-tag.light { color: rgba(255,255,255,0.8); border-color: rgba(255,255,255,0.4); }

.ph-upcoming {
  padding: 0.9rem 0.6rem 1rem;
  background: linear-gradient(to top left, #814e54, #545f65, #8cafb8);
}
.ph-upcoming h2 { font-size: 0.34rem; font-weight: 600; color: #FFFFFF; margin: 0.3rem 0 0.1rem; }
</style>